import I18n from 'I18n';
export const getDefaultArticleName = isUngated => isUngated ? I18n.text('knowledgeArticleDescriptions.title') : 'What question is your article answering?';